<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters"  size="mini">
				<el-form-item label="项目名称">
                    <el-cascader  :options="projects" :props="defaultProps" collapse-tags :show-all-levels="false" clearable filterable v-model="filters.projectId" style="width:350px" ></el-cascader>
				</el-form-item>
				<el-form-item label="时间范围">
					<el-date-picker
                        v-model="filters.time"  type="daterange" unlink-panels :picker-options="pickerOptions" 
                        range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期"  align="right">
                    </el-date-picker>
                </el-form-item>
				<el-form-item>
                    <my-button  @select-type="clickBtn" QueryButtonShow ExportButtonShow ResetButtonShow></my-button>
				</el-form-item>
			</el-form>
		</el-col>

		<el-table :data="dataList" border  highlight-current-row v-loading="listLoading" style="width: 100%;"   size="small" id="mytable">
			<el-table-column type="index" label="序号"  ></el-table-column>
            <el-table-column prop="functionalAreaName" label="功能区类型"    ></el-table-column>
            <el-table-column prop="count" label="个数" ></el-table-column>
            <el-table-column label="昼间" >
                <el-table-column prop="dayData" label="dB" ></el-table-column>
			    <el-table-column prop="dayRate" label="%" ></el-table-column>
            </el-table-column>
            <el-table-column  label="夜间" >
                <el-table-column prop="nightData" label="dB"  ></el-table-column>
			    <el-table-column prop="nightRate" label="%" ></el-table-column>
            </el-table-column>
		</el-table>

        <el-col :span="24"   v-loading="listLoading">
            <div id="chartLine"></div>
        </el-col>
	</section>
</template>

<script>
	import { getProjects,getComplianceRate} from '../../api/api';
	import {formatDate,translateDataToTreeProject} from '../../../static/fun.js';
    import * as echarts from "echarts";   

    import myButton from '../../components/myButton/index.vue'

	export default {
        props: {
            collapsed: {
                type: Boolean,
            },
        },
        components: { myButton },
		data() {
			return {
				pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                        }
                    }]
                },
				filters: {
					projectId:"",
					time:[]
				},
				listLoading: false,
				dataList:[],
				projects:[],

                userId:sessionStorage.getItem('userId'),
                chartLine:null,
                formHeight:0,
                defaultProps:{
					multiple: true,
					children: "children",
          			label: "name",
					value:"projectId"
				}
			}
			
		},
        watch: {
            'collapsed': {
                handler (val) {
                    if(this.chartLine!=null){
                        this.chartLine.resize();
                    }
                },
                deep: true
            },
        },
		methods: {
            reset(){
                this.filters={
                    projectId:"",
                    time:[]
                }
            },
            clickBtn(type){
				if(type=="query"){
					this.getComplianceRate();
				}else if(type=="export"){
					this.exportData();
				}else if(type=="reset"){
					this.reset();
				}
			},
            exportData(){
                require.ensure([], () => {
                    let tHeader2=['功能区类型','个数','昼间','','夜间',''];
                    let tHeader1=['','','dB','%','dB','%'];
                    let merges = [
                        "A1:A2",
                        "B1:B2",
                        "C1:D1",
                        "E1:F1"
                    ]; 
                    const { export_json_to_excel_many } = require('vendor/Export2Excel');
                    const filterVal = ['functionalAreaName', 'count', 'dayData','dayRate','nightData','nightRate' ];  

                    var data=[];
                    data.push(this.formatJson(filterVal, this.dataList));

                    var sheetName=[];
                    sheetName.push('Sheet1');

                    export_json_to_excel_many(tHeader1,tHeader2,data, '达标率统计数据',sheetName,merges);

                }) 
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            }, 
            getComplianceRate(){
                var starttime='';
                var endtime='';
                if(this.filters.time!=null&&this.filters.time.length>0){
                    starttime=formatDate(this.filters.time[0]);
					endtime=formatDate(this.filters.time[1]);

                    if((parseInt(this.filters.time[1] - this.filters.time[0]) / 1000 / 60/ 60)<24){
                        this.$message({
                            message: "时间范围小于1天，请重新选择",
                            type: 'warn'
                        })
                        return;
                    }

                }
				let para = {
                    userId:this.userId,
					startDate: starttime,
                    endDate: endtime
				};
                if(this.filters.projectId!=""){
					para.projectId=this.filters.projectId.toString();
				}
                 if(para.startDate==""){
                    this.$message({
                        message: "请选择时间",
                        type: 'warn'
                    })
                    return;
                }
                if(para.userId==""||para.userId==undefined){
                    this.$message({
                        message: "用户已离线，请重新登录",
                        type: 'warn'
                    })
                    this.$router.push({ path: '/login' });
                    return;
                }
				this.listLoading = true;
                getComplianceRate(para).then((res) => { 
                    this.listLoading = false;
                    if(res.data.result==false){
                        this.$message({
                            message: "查询出错,请重试",
                            type: 'warn'
                        })
                        return;
                    }else{
                        this.dataList = res.data.data; 
                        var aData=[];
                        var seriesData=[
                            {
                                type:'bar',
                                name:'昼间',
                                color:'#4DA2F7',
                                data:[]
                            },
                            {
                                type:'bar',
                                name:'夜间',
                                color:'#ED8A46',
                                data:[]
                            }
                        ];
                        this.dataList.forEach(element => {
                            aData.push(element.functionalAreaName);
                            seriesData[0].data.push(element.dayRate);
                            seriesData[1].data.push(element.nightRate);
                        });
                        this.drawLineChart(aData,seriesData);
                    }
                });
            },
            drawLineChart:function(aData,seriesData) {
                this.chartLine = echarts.init(document.getElementById('chartLine'));
                this.chartLine.setOption({
                      tooltip: {
                        trigger: 'axis',
                        formatter: function(params) {
                            var result = params[0].name+'<br>';
                            params.forEach(function(item) {
                                result +=item.seriesName+" : "+'<span style="display:inline-block;min-width:80px">'+ item.data+"%</span><br>"
                            });
                            return result;
                        },
                    },
                    toolbox: {
                        show : true,
                        feature: {
                            saveAsImage: {
                                show:true,
                                excludeComponents :['toolbox'],
                                pixelRatio: 2
                            }
                        }
                    },
                    legend: {
                        data: ["昼间","夜间"],
                        itemWidth: 10,  // 设置宽度
                        itemHeight: 10, // 设置高度
                    },
                    grid: {
                        left: '3%',
                        right: '6%',
                        bottom: '4%',
                        top:60,
                        containLabel: true
                    },
                    xAxis: {
                        name:'功能区类别',
                        data:aData
                    },
                    yAxis: {
                        type: 'value',
                        name:'达标率(%)',
                    },
                    series:seriesData
                 },true);
            },
             //查询项目信息
             getProjects() {
				this.listLoading = true;
                getProjects().then((res) => {
                    this.projects=translateDataToTreeProject(res.data.data);
					this.listLoading = false;
			        if(this.projects.length>0){
						this.filters.projectId=this.projects[0].projectId;
                        this.getComplianceRate();
					}
				});
			},
		
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				this.formHeight=(hgt-titleHgt-120)*0.45;

                
                var chartLineDiv=document.getElementById("chartLine");
                if(chartLineDiv!='-'){
                    chartLineDiv.style.height=this.formHeight+"px";
                    document.getElementById("mytable").style.height=this.formHeight+"px";
                }
			},
			setTime(){
				var end = new Date();
                end.setHours(0);
                end.setMinutes(0);
                end.setSeconds(0);
				var start = new Date();
                start.setHours(0);
                start.setMinutes(0);
                start.setSeconds(0);
                start.setTime(start.setDate(start.getDate()-7));
				this.filters.time= [formatDate(start), formatDate(end)];
				this.getProjects();
			}
		},
		mounted() {
			var _this=this;
			var timer='-';
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)

            window.onresize = function(){
                if(_this.chartLine!=null){
                    _this.chartLine.resize();
                }
            }
			
			this.setTime();
		},
	}

</script>

<style>
	.cell{
		text-align: center;
	}
	.timeFar{
		float: right;
		margin-right: 20px;
	}
	.el-form{
		overflow: hidden;
	}
	.el-col-1{
        text-align: center;
    }
    #mytable{
        margin-bottom: 10px;
        overflow-y: auto;
    }
</style>


// WEBPACK FOOTER //
// ComplianceRate.vue?c519b50e